import { Map } from 'immutable'
import { AsyncState, loadingAsyncState, Pair } from 'widgets-for-react'
import { ImageSize, Url } from '../../cms/blocks/types.gen'
import { Block } from '../types_and_parser/standard_blocks.gen'
import { PairAsyncImage } from '../../cms/state/types.gen'
import { ExtraImages } from '../../public_site/utils/extra_images.mod'
import { isCustomBlock } from '../../public_site/blocks/custom_blocks/types.mod'
import { WordPress } from '../wordpress_api'
import { CustomBlock } from '../types_and_parser/custom_blocks.mod'

export function loadMedia(image: number): AsyncState<Map<ImageSize<ExtraImages>, Url>> {
  return loadingAsyncState<Map<ImageSize<ExtraImages>, Url>>(_ => {
    return WordPress.media<WordPress.MediaResponse>()
      .findById(image)
      .then(response => {
        const sizes = response.data.media_details.sizes
        let value = Map<ImageSize<ExtraImages>, Url>().set('full', sizes.full.source_url)
        if (sizes.thumbnail) value = value.set('thumbnail', sizes.thumbnail.source_url)
        if (sizes.medium) value = value.set('medium', sizes.medium.source_url)
        if (sizes.medium_large) value = value.set('medium_large', sizes.medium_large.source_url)
        if (sizes.large) value = value.set('large', sizes.large.source_url)

        if (sizes.header_s) value = value.set('header_s', sizes.header_s.source_url)
        if (sizes.header_m) value = value.set('header_m', sizes.header_m.source_url)
        if (sizes.header_l) value = value.set('header_l', sizes.header_l.source_url)
        if (sizes.header_xl) value = value.set('header_xl', sizes.header_xl.source_url)

        if (sizes.story_header_s) value = value.set('story_header_s', sizes.story_header_s.source_url)
        if (sizes.story_header_m) value = value.set('story_header_m', sizes.story_header_m.source_url)
        if (sizes.story_header_l) value = value.set('story_header_l', sizes.story_header_l.source_url)

        if (sizes.portrait_s) value = value.set('portrait_s', sizes.portrait_s.source_url)
        if (sizes.portrait_m) value = value.set('portrait_m', sizes.portrait_m.source_url)
        if (sizes.portrait_l) value = value.set('portrait_l', sizes.portrait_l.source_url)
        if (sizes.portrait_xl) value = value.set('portrait_xl', sizes.portrait_xl.source_url)

        if (sizes.media_block_s) value = value.set('media_block_s', sizes.media_block_s.source_url)
        if (sizes.media_block_m) value = value.set('media_block_m', sizes.media_block_m.source_url)
        if (sizes.media_block_l) value = value.set('media_block_l', sizes.media_block_l.source_url)

        return { status: 200, value, kind: 'result' as 'result' }
      })
      .catch(error => {
        console.error(error)
        return { status: 400, kind: 'failed' as 'failed' }
      })
  })
}

export const WordPressBlockImagesLoader = (
  block: Block | CustomBlock,
  get_images_from_custom_block?: (b: CustomBlock) => Array<PairAsyncImage<ExtraImages>>
): Array<Pair<number, AsyncState<Map<ImageSize<ExtraImages>, Url>>>> => {
  switch (block.kind) {
    default:
      if (get_images_from_custom_block && isCustomBlock(block)) {
        return get_images_from_custom_block(block)
      }
      return []
  }
}
